import type { RootState } from "single-spa/store/types";

const selectSegmentsModule = (state: RootState) => state.segmentsModule;

export const selectSegmentsMeta = (state: RootState) => state.segmentsModule?.customSegmentsMeta;

export const selectAccountSegments = (state: RootState) => state.segmentsModule?.customSegmentsMeta?.AccountSegments;

const selectIsSegmentsLoading = (state: RootState) => state.segmentsModule?.segmentsLoading;

const selectSegmentGroups = (state: RootState) => state.segmentsModule?.customSegmentsMeta?.SegmentGroups;

const selectSegments = (state: RootState) => state.segmentsModule?.customSegmentsMeta?.Segments;
